export const DEFAULT_TIMEZONE = 'Asia/Taipei';

export const REQUEST_DATE_FORMAT = 'YYYY-MM-DD';

export const APP_DATE_FORMAT = 'MM/DD/YYYY';

export const APP_TIME_FORMAT = 'hh:mm:ss A';

export const APP_DATE_FORMAT_WITH_TIME = 'YYYY-MM-DD hh:mm:ss A';

export const MONTH = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
